// extracted by mini-css-extract-plugin
module.exports = {"slide":"OrderBlock_slide_Wn2Hr","slide-reverse":"OrderBlock_slide-reverse_1BnSD","order-expanded":"OrderBlock_order-expanded_3oKeH"};